"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _invoice = _interopRequireWildcard(require("@/api/invoice/invoice"));
var invoice = _invoice;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'invoiceOrderList',
  components: {},
  data: function data() {
    return {
      dialogVisibleJI: false,
      LogLoading: false,
      dialogVisible: false,
      tableData: {
        data: [],
        total: 0
      },
      timeVal: [],
      listLoading: false,
      tableFrom: {
        status: -1,
        dateLimit: '',
        keywords: '',
        page: 1,
        limit: 20
      },
      fromList: this.$constants.fromList,
      selectionList: [],
      checkAll: false,
      card_select_show: false,
      isIndeterminate: true,
      tableDataLog: {
        data: [],
        total: 0
      },
      tableFromLog: {
        page: 1,
        limit: 10000,
        skuIds: null,
        status: null
      },
      skuIds: null
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    resetFormRefusehand: function resetFormRefusehand() {
      this.RefuseVisible = false;
    },
    resetForm: function resetForm(formValue) {
      this.dialogVisible = false;
    },
    searchList: function searchList() {
      this.tableFrom.page = 1;
      this.getList();
    },
    sendAddress: function sendAddress(data) {
      this.dialogVisibleJI = true;
      this.tableFromLog.skuIds = data.skuId;
      this.tableFromLog.status = data.invoiceStatus;
      this.onOrderLog(this.tableFromLog);
    },
    sendOrder: function sendOrder() {
      var _this = this;
      this.LogLoading = true;
      var data = [];
      this.tableDataLog.data.map(function (item) {
        data.push(item.subDistributionOrderId);
      });
      invoice.invoiceSendStoreOrderApi({
        orderNos: data
      }).then(function (res) {
        _this.$message.success('配送完成');
        _this.skuIds = null;
        _this.dialogVisibleJI = false;
        _this.searchList();
        _this.LogLoading = false;
      }).catch(function () {
        _this.$message.success('配送失败');
        _this.LogLoading = false;
      });
    },
    // 订单记录
    sendHandler: function sendHandler() {
      if (!this.skuIds) {
        this.$message.warning('请选择要配送的商品');
        return;
      }
      this.dialogVisibleJI = true;
      this.tableFromLog.skuIds = this.skuIds;
      this.tableFromLog.status = this.tableFrom.status;
      this.onOrderLog(this.tableFromLog);
    },
    // 订单记录
    onOrderLog: function onOrderLog() {
      var _this2 = this;
      this.LogLoading = true;
      invoice.invoiceOrderListApi(this.tableFromLog).then(function (res) {
        _this2.tableDataLog.data = res.list;
        _this2.tableDataLog.total = res.total;
        _this2.LogLoading = false;
      }).catch(function () {
        _this2.LogLoading = false;
      });
    },
    pageChangeLog: function pageChangeLog(page) {
      this.tableFromLog.page = page;
      this.onOrderLog();
    },
    handleSizeChangeLog: function handleSizeChangeLog(val) {
      this.tableFromLog.limit = val;
      this.onOrderLog();
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectionList = val;
      var data = [];
      this.selectionList.map(function (item) {
        data.push(item.skuId);
      });
      this.skuIds = data.join(',');
    },
    // 选择时间
    selectChange: function selectChange(tab) {
      this.timeVal = [];
      this.tableFrom.page = 1;
      this.getList();
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.tableFrom.page = 1;
      this.getList();
    },
    // 列表
    getList: function getList() {
      var _this3 = this;
      this.listLoading = true;
      invoice.invoiceSummaryOrderApi(this.tableFrom).then(function (res) {
        _this3.tableData.data = res.list || [];
        _this3.tableData.total = res.total;
        _this3.listLoading = false;
      }).catch(function () {
        _this3.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    exports: function exports() {
      var _this4 = this;
      this.listLoading = true;
      invoice.invoiceOrderExcelApi(this.tableFromLog).then(function (res) {
        window.open(res.fileName);
        _this4.listLoading = false;
      });
    },
    renderHeader: function renderHeader(h) {
      var _this5 = this;
      return h("p", [h("span", {
        "style": "padding-right:5px;"
      }, ["\u914D\u9001\u7F51\u70B9"]), h("i", {
        "class": "el-icon-setting",
        "on": {
          "click": function click() {
            return _this5.handleAddItem();
          }
        }
      })]);
    },
    handleAddItem: function handleAddItem() {
      if (this.card_select_show) {
        this.$set(this, 'card_select_show', false);
      } else if (!this.card_select_show) {
        this.$set(this, 'card_select_show', true);
      }
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.columnData : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnData.length;
    },
    checkSave: function checkSave() {
      this.$set(this, 'card_select_show', false);
      this.$modal.loading('正在保存到本地，请稍候...');
      this.$cache.local.setJSON('order_stroge', this.checkedCities);
      setTimeout(this.$modal.closeLoading(), 1000);
    },
    //打印小票
    onOrderPrint: function onOrderPrint(data) {
      var _this6 = this;
      orderPrint(data.orderNo).then(function (res) {
        _this6.$modal.msgSuccess('打印成功');
      }).catch(function (error) {
        _this6.$modal.msgError(error.message);
      });
    }
  }
};